import './GridList.scss'

import React from 'react'

/**
 * @param {Object} props
 * @param {string} [props.id]
 * @param {boolean} [props.loading]
 * @param {number} [props.count]
 * @param {() => React.ReactNode} [props.renderPlaceholder]
 * @param {Array} [props.items]
 * @param {(item: *) => React.ReactNode} [props.renderItem]
 * @param {*} [props.highlight] Item (contained in items) that will be highlighted
 * @param {boolean} [props.row]
 * @param {() => React.ReactNode} [props.renderDisruptor]
 */
const GridList = ({
    id, loading, count, renderPlaceholder, items, renderItem, highlight, row, renderDisruptor,
}) => {
    let classes = row ? 'grid-list-row' : 'grid-list'
    if (highlight) classes += ' has-highlight'
    if (loading) classes += ' loading'

    return (
        <ul id={id} className={classes}>
            {loading ? (
                Array.from(Array(count).keys()).map(i => (
                    <li key={i}>
                        {renderPlaceholder()}
                    </li>
                ))
            ) : (
                items.reduce((renderedItems, item, i) => {
                    if (i === 5 && renderDisruptor) {
                        renderedItems.push(
                            <li key={i + '-disruptor'} className='disruptor-item'>
                                {renderDisruptor()}
                            </li>
                        )
                    }
                    renderedItems.push(
                        <li key={i} className={(item === highlight) ? 'highlight' : null}>
                            {renderItem ? renderItem(item) : item}
                        </li>
                    )
                    return renderedItems
                }, [])
            )}
        </ul>
    )
}

export default GridList
